import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TwoColumnListContentLayoutModule } from 'src/app/common-components/column-layouts/two-column-list-layout/two-column-list-layout.module';
import { RegisterModule } from 'src/app/common-components/register/register.module';
import { FormatNameLengthPipeModule } from 'src/app/pipes/format-name-length-pipe/call-cost-pipe.module';
import { LocationModule } from 'src/app/pipes/location/location.module';
import { AddSpacesPipeModule } from 'src/app/pipes/split-enum-strings/add-spaces-pipe.module';
import { DepartmentDetailModule } from '../department-details/department-detail.module';
import { MergeDepartmentModule } from '../merge-department/merge-department.module';
import { ModifyDepartmentModule } from '../modify-department/modify-department.module';
import { DepartmentRegisterComponent } from './container/department-register.component';
import { DepartmentWrapperComponent } from './container/department-wrapper.component';
import { DepartmentRegisterEffects } from './state/department-register.effects';
import { departmentRegisterFeatureKey, departmentRegisterReducer } from './state/department-register.reducer';
import { DepartmentRegisterViewComponent } from './views/department-register-view.component';

@NgModule({
   declarations: [DepartmentRegisterComponent, DepartmentRegisterViewComponent, DepartmentWrapperComponent],
   imports: [
      CommonModule,
      FormsModule,
      LcsCallStatePipeModule,
      LcsLoadingOverlayModule,
      LcsResponsiveTableModule,
      MatMenuModule,
      TwoColumnListContentLayoutModule,
      MatButtonModule,
      AddSpacesPipeModule,
      DepartmentDetailModule,
      MatInputModule,
      MatTooltipModule,
      FormatNameLengthPipeModule,
      MatIconModule,
      MatCheckboxModule,
      ReactiveFormsModule,
      ModifyDepartmentModule,
      MergeDepartmentModule,
      MatSlideToggleModule,
      RouterModule,
      ScrollingModule,
      RegisterModule,
      LocationModule,
      EffectsModule.forFeature([DepartmentRegisterEffects]),
      StoreModule.forFeature(departmentRegisterFeatureKey, departmentRegisterReducer),
   ],
})
export class DepartmentRegisterModule {}
